import { makeStyles } from '@material-ui/core';
import { vivaTokensFor } from '../../theme';
import LogoIcon from './LogoIcon';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
  },
  text: {
    color: vivaTokensFor(theme.palette.type).logo.text,
    fontSize: 21,
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1,
  },
}));

/** Логотип платформы для развёрнутого сайдбара: знак «Пульс» + название ViVA. */
const LogoFull = () => {
  const classes = useStyles();
  return (
    <span className={classes.root}>
      <LogoIcon />
      <span className={classes.text}>ViVA</span>
    </span>
  );
};

export default LogoFull;
